import { ComponentProps, FC } from "react";
import { twCn } from "@/styles/utils";

export const CabinetCard: FC<ComponentProps<"div">> = ({
  children,
  className,
  ...props
}) => (
  <div
    {...props}
    className={twCn(
      "flex-col-gap-6 bg-light lgc:rounded-2xl overflow-hidden rounded-xl p-4",
      className,
    )}
  >
    {children}
  </div>
);
